var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator-ball"},[_c('div',{staticClass:"indicator-ball__outer-circle",class:`bg-color-${_vm.variant}-light`},[_c('div',{staticClass:"indicator-ball__inner-circle",class:`bg-color-${_vm.variant}`},[_c('div',{staticClass:"indicator-ball__content"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }